module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "vbl-button",
    class: _vm.classes,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [(_vm.icon) ? _c('vbl-icon', {
    attrs: {
      "type": _vm.icon
    }
  }) : _vm._e(), _c('span', [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb7139ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblButton/src/vblButton.vue
// module id = 290
// module chunks = 0